import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import '@mdi/font/css/materialdesignicons.css'
import vuetify from './plugins/vuetify'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { apiService } from '@/services/api'
import { useAuthStore } from '@/stores/useAuthStore' // ← make sure this path matches exactly

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(vuetify)

// Must be AFTER app.use(pinia)
const authStore = useAuthStore(pinia) // ← pass pinia instance explicitly
apiService.setAuthStore(() => useAuthStore(pinia)) // ← always resolves to same instance

console.log('Token on startup:', authStore.token ? 'EXISTS' : 'MISSING')

app.mount('#app')
